import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as World } from 'assets/svg/icon-world.svg'

function IconWorld(props: IconProps): JSX.Element {
  const title = 'icon-world'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <World {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconWorld
